import { useEffect } from 'react'
import { useConfigCatClient } from 'configcat-react'

export function ConfigCatForceRefresh() {
  const client = useConfigCatClient()

  useEffect(() => {
    client.forceRefreshAsync()
  }, [client])

  return null
}
